import {getAvatars, getExtraGuestsCount, isTicketed} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {AvatarGroup, AvatarGroupSize, TextButtonPriority} from 'wix-ui-tpa/cssVars'
import {useAppActions, useAppSelector} from '../../hooks/runtime'
import {getEvent, getMembers, getTotalGuests} from '../../selectors/event'
import {classes} from './members.st.css'

const MAX_AVATARS = 7
const MAX_ONLY_ANONYMOUS_AVATARS = 3

export const Members = () => {
  const event = useAppSelector(getEvent)
  const members = useAppSelector(getMembers)
  const totalGuests = useAppSelector(getTotalGuests)
  const {openMembersModal} = useAppActions()
  const {isMobile: mobile} = useEnvironment()
  const {t} = useTranslation()
  const items = getAvatars(members, totalGuests, !isTicketed(event), MAX_AVATARS)

  const hasMemberAvatars = items.filter(item => item.name).length
  const hasMembers = members.length

  const maxAvatars = hasMemberAvatars ? MAX_AVATARS : MAX_ONLY_ANONYMOUS_AVATARS
  const extraGuests = getExtraGuestsCount(totalGuests, maxAvatars)
  const label =
    !hasMembers && extraGuests ? t('members.moreGuestsLink', {amount: extraGuests}) : t('members.seeAllGuestsLink')

  const onClick = () => openMembersModal(event.id)

  return (
    <div className={classNames(classes.root)} data-hook={DH.EVENT_DETAILS_MEMBERS}>
      <AvatarGroup
        className={classNames(classes.avatars)}
        maxAmount={maxAvatars}
        items={items}
        size={mobile ? AvatarGroupSize.medium : AvatarGroupSize.large}
      >
        <AvatarGroup.TextButton
          priority={mobile ? TextButtonPriority.link : TextButtonPriority.primary}
          aria-haspopup="dialog"
          onClick={onClick}
        >
          {label}
        </AvatarGroup.TextButton>
      </AvatarGroup>
    </div>
  )
}
